// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getMainAccount, insertMainAccount, mainAccountSelector, updateMainAccount} from './mainAccountSlice';

import {Colors} from "../../../assets/Colors";

const MainAccountPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const mainAccount = useSelector(
        mainAccountSelector
    );

    useEffect(() => {
        dispatch(getMainAccount({
            start: start,
            count: count,
            search: '',
        }));
    }, []);

    useEffect(() => {

        if ((search !== '') && mainAccount.isGetSuccess && !mainAccount.isGetFetching) {
            let calc = mainAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = mainAccount.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && mainAccount.isGetSuccess && !mainAccount.isGetFetching) {
            let calc = mainAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = mainAccount.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!mainAccount?.isGetFetching && mainAccount.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = mainAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = mainAccount.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getMainAccount({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (mainAccount.isGetSuccess) {
                alertService.success(mainAccount.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getMainAccount({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (mainAccount.isUpdateSuccess) {
                alertService.success(mainAccount.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateMainAccount({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetMainAccount(params) {
    //   return dispatch(getMainAccount(params));
    // }

    function handleInsertMainAccount(param) {
        setInsertFetch(true);
        const params = {
            MainAccount: param.inputTwoValue,
            MainAccountID: param.inputOneValue,
        };
        dispatch(insertMainAccount(params));
    }

    function handleUpdateMainAccount(param) {
        setUpdateFetch(true);

        const params = {
            MainAccount: param.inputOneValue,
            MainAccountID: currentData.MainAccountID,
            status: param.status,
        };
        dispatch(updateMainAccount(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getMainAccount(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getMainAccount(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (mainAccount.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? mainAccount.count : newCount,
            search: search,
        }
        dispatch(getMainAccount(params));

        setPage(1);
        setCount((newCount === "-1") ? mainAccount.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                handleSearch={handleSearch}
                                searchPlaceholder="MainAccount"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master MainAccount"
                                tableData={mainAccount.data}
                                colOneTitle="ID"
                                colOneData="MainAccountID"
                                colTwoTitle="Nama Main Account"
                                colTwoData="MainAccount"
                                status="Status"

                                fetching={mainAccount.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Main Account"
                        inputOneTitle="ID Main Account"
                        inputOnePlaceholder=""
                        inputTwoTitle="Nama Main Account"
                        inputTwoValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertMainAccount}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.MainAccountID}
                        modal={handleModal}
                        modalTitle="Ubah Main Account"
                        inputOneTitle="Nama Main Account"
                        inputOneValue={currentData.MainAccount}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateMainAccount}
                    />
                }
            </div>

        )
    }

}


export default MainAccountPage;